import Sidebar from "components/navigation-2/sidebar";
import AgentRankNavigationMenu from "components/agent-rank/AgentRankNavigationMenu";

export default function LayoutAgentRank({ children }) {
  return (
    <div className="page">
      <Sidebar>
        {/* Agent Rank Navigation Menu - appears below topbar */}
        <AgentRankNavigationMenu />
        
        <div className="page-wrapper agent-rank-scope">
          {children}
        </div>
      </Sidebar>
    </div>
  );
}